import React from 'react'
import { getFirstSubstring } from '../helpers'
import { FleetDataType } from 'src/core/models'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  CustomLink,
  CustomText,
  FleetListActionsColumn,
  FleetListMovileViewColumn
} from 'src/components'

const fleetListColumns: ColumnsType<FleetDataType> = [
  {
    title: () => <CustomHeaderText text={'Cabify.Country'} />,
    dataIndex: 'country',
    responsive: ['sm'],
    sorter: (a, b) => a.country.length - b.country.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, fleet) => <CustomText label={fleet.country} strong />
  },
  {
    title: () => <CustomHeaderText text={'Cabify.Period'} />,
    dataIndex: 'period',
    responsive: ['sm'],
    sorter: (a, b) => a.period.length - b.period.length,
    sortDirections: ['descend', 'ascend'],
    render: (_, fleet) => <CustomText label={fleet.period} />
  },
  {
    title: () => <CustomHeaderText text='Cabify.File' isCentered />,
    dataIndex: 'file',
    sorter: (a, b) => a.period.length - b.period.length,
    sortDirections: ['descend', 'ascend'],
    responsive: ['sm'],
    render: (_, fleet) => {
      const fileName = (fleet.file as string).split('/').pop()
      return <CustomLink
        link={fleet.file as string}
        label={`${getFirstSubstring(fileName, 10)}...`}
        showIcon={true}
      />
    }
  },
  /* Actions  */
  {
    title: () => <CustomHeaderText text='general.Actions' />,
    responsive: ['sm'],
    render: (_, fleet) => <FleetListActionsColumn fleet={fleet} />
  },
  /* Mobile View */
  {
    title: () => <CustomHeaderText text='Cabify.Fleets' isCentered />,
    responsive: ['xs'],
    sorter: (a, b) => a.country.length - b.country.length,
    render: (_, fleet) => <FleetListMovileViewColumn fleet={fleet} />
  },
]

export default fleetListColumns
